module.exports = __webpack_public_path__ + "media/images/pack_sub_icon-90e64456408689b3af2a4cb315e49f83.svg";